module.exports = __webpack_public_path__ + "img/dashboard-active.1037987e.svg";